<template>
  <div class="relative inline-block text-left">
    <!-- Toggle button -->
    <button
      type="button"
      class="flex items-center p-1 rounded-md text-primary-font text-sm font-bold hover:opacity-80 transition select-none cursor-pointer"
      @click.stop="toggleDropdown"
    >
      <i class="fas fa-book mr-1" />
      <span>{{ $t('menu.documentMgm') }}</span>
    </button>

    <!-- Dropdown -->
    <div
      v-if="open"
      class="absolute right-0 mt-2 w-40 origin-top-right bg-white border border-primary-font/30 rounded-lg shadow-xl overflow-hidden z-50"
    >
      <ul class="text-sm text-primary-font">
        <li
          v-for="(listdoc, index) in dropdownDownload"
          :key="index"
          class="flex items-center px-3 py-2 hover:bg-primary cursor-pointer"
          @click="selectDoc(listdoc)"
        >
          <img :src="listdoc.pic" alt="" class="w-5 h-5 object-cover" />
          <span class="ml-2">{{ listdoc.name }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { getModule } from 'vuex-module-decorators';

import DocumentModule from '@/store/modules/Document';
import thai from '@/assets/images/thailand.png';
import usa from '@/assets/images/usa.png';
import store from '@/store';

export default defineComponent({
  name: 'DocDownload',

  data() {
    return {
      open: false,
      dropdownDownload: [
        {
          name: 'คู่มือภาษาไทย',
          filename: 'AMBSlotAGENT_V.TH',
          value: 'documentTh',
          pic: thai
        },
        {
          name: 'User Manual',
          filename: 'AMBSlotAGENT_V.ENG',
          value: 'documentEn',
          pic: usa
        }
      ],
      DocumentInstance: getModule(DocumentModule, store) as any
    };
  },

  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  },

  methods: {
    toggleDropdown() {
      this.open = !this.open;
    },

    handleClickOutside(event: MouseEvent) {
      const root = this.$el as HTMLElement | null;
      const target = event.target as Node | null;
      if (!root || !target) return;
      if (this.open && !root.contains(target)) {
        this.open = false;
      }
    },

    selectDoc(item: any) {
      this.downloadDoc(item);
      this.open = false;
    },

    async downloadDoc(item: any) {
      const payload = {
        documentName: item.value
      };

      await this.DocumentInstance.DownloadDocument(payload);

      const dataFile = this.DocumentInstance.dataFile?.dataFile ?? this.DocumentInstance.dataFile;

      if (!dataFile) return;

      const fileURL = window.URL.createObjectURL(new Blob([dataFile]));
      const fileLink = document.createElement('a');

      fileLink.href = fileURL;
      fileLink.setAttribute('download', `${item.filename}.pdf`);
      document.body.appendChild(fileLink);
      fileLink.click();
      fileLink.remove();
      window.URL.revokeObjectURL(fileURL);
    }
  }
});
</script>
